import * as req from 'api/actions';
import * as c from './constant';

// eslint-disable-next-line import/prefer-default-export
export const generateMiscFeeReport = (payload, callback) =>
  req.list(
    c.GENERATE_MISC_FEE_REPORT,
    '/api/v1/administrators/transaction_histories/miscellaneous_fee_payments/check_records',
    payload,
    callback
  );
